module.exports = __webpack_public_path__ + "images/module-2-programming-for-data-science.png";